import { observer } from 'mobx-react-lite'
import { AllSelection } from 'prosemirror-state'
import { computed } from 'mobx'
import { useModals } from 'almanac-ui/Modal'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { ChangeToneModal } from 'components/BlazeCommandLine/modals/ChangeToneModal'
import { useAlmanacEditorState } from 'stores/EditorState'
import { useRootStore } from 'stores/RootStore'
import { AIAssistantProps } from '../Types'
import { Action, ActionProps } from './Action'
import { ChangeTone as ChangeToneIcon } from 'blaze-ui/icons/36'
import cx from 'classnames'

export const ChangeTone = observer(function ChangeTone({
  article,
  layerId,
  className,
  ...props
}: AIAssistantProps & Omit<ActionProps, 'label' | 'tooltip'>) {
  const { openModal } = useModals()
  const editorState = useAlmanacEditorState()
  const { docStore } = useRootStore()

  const containsAiSuggestionNode = computed(() =>
    editorState?.allNodeTypes.has(editorState.view.state.schema.nodes.ai_suggestion),
  ).get()

  const handlePress = () => {
    if (!editorState || containsAiSuggestionNode) return

    const selection = editorState.selection.empty ? new AllSelection(editorState.view.state.doc) : editorState.selection

    if (
      selection.empty ||
      selection.content().content.textBetween(0, selection.content().content.size).trim().length < 1
    ) {
      showToastMessage(`Try selecting some text you'd like Blaze to change tone!`, 'info')
      return
    }

    if (!docStore?.rightRailStore.locked) {
      docStore?.rightRailStore.setActiveTab(undefined)
    }

    openModal(ChangeToneModal, {
      articleId: article.id,
      layerId,
      selection: selection.toJSON(),
      almanacEditorState: editorState,
    })
  }

  return (
    <Action
      tooltip={
        containsAiSuggestionNode
          ? 'Click Done to accept your generated content before changing tone'
          : 'Select a new tone for your doc'
      }
      label="Edit Tone"
      icon={ChangeToneIcon}
      isDisabled={containsAiSuggestionNode}
      {...props}
      className={cx(className, 'blog-post-output-tour-1')}
      onPress={handlePress}
    />
  )
})
